module.exports = __webpack_public_path__ + "img/logo.ff08e37.png";